import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography } from "@mui/material";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import CheckIcon from "@mui/icons-material/Check";

import GradientIcon from "../components/GradientIcon";
import HaveQuestions from "../components/HaveQuestions";
import immrsExpBg from "../assets/Immersive-Experience-bg.png";
import immrsInfographicBg from "../assets/Immersive-Experience-Infographic.png";
import halfCircles from "../assets/half-circles.png";

const ImmersiveExperience = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Helmet>
        <title>DAM Journey - Immersive Experience</title>
        <meta
          name="description"
          content="Immersive Experience, We opt in for an immersive experience. This means that we work the details with practitioners in your organization in a real-life and real-time learning journey. We accomplish this by executing our proprietary DAM playbook with you and your team members as active contributors. This also means no webinars and certainly no certification classes"
        />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, Immersive Experience"
        />
      </Helmet>
      <Box /*sx={{ maxWidth: "1440px" }}*/>
        {/* Hero Banner Section */}
        <Box
          sx={{
            width: "100%",
            height: "350px",
            background: "linear-gradient(0deg, #2A2177 0%, #0624BE 100%)",
            display: "flex",
            alignItems: "center",
            pl: "84px",
            pr: "189px",
            py: "60px",
            overflow: "hidden",
            position: "relative",
            "@media (max-width: 1200px)": {
              px: "24px",
              py: "60px",
            },
            "@media (max-width: 780px)": {
              flexDirection: "column",
              textAlign: "center",
              px: "16px",
              pt: "32px",
              pb: 2,
              height: "520px",
            },
          }}
        >
          {/* Left Text Content */}
          <Box
            sx={{
              flex: 2,
              zIndex: 1,
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: "2.5rem",
                fontWeight: 700,
                color: "#ffffff",
                lineHeight: 1.3,
                mb: 2,
                "@media (max-width: 1200px)": {
                  fontSize: "1.75rem",
                  fontWeight: "semiBold",
                },
                "@media (max-width: 780px)": {
                  fontSize: "1.5rem",
                  mb: 1,
                },
              }}
            >
              Immersive Experience
              <Box
                component="sup"
                sx={{
                  fontSize: "32px",
                  fontWeight: 400,
                  verticalAlign: "super",
                }}
              >
                ®
              </Box>
            </Typography>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "regular",
                color: "#ffffff",
                lineHeight: 1.7,
                maxWidth: "624px",
                "@media (max-width: 1200px)": {
                  fontSize: "18px",
                },
                "@media (max-width: 780px)": {
                  fontSize: "16px",
                  mb: 2,
                },
              }}
            >
              We opt in for an immersive experience. This means
              that we work the details with practitioners in
              your organization in a real-life and real-time
              learning journey. We accomplish this by executing
              our proprietary DAM playbook with you and your team
              members as active contributors. This also means
              no webinars and certainly no  certification classes.
            </Typography>
          </Box>

          {/* Right Immrs-Exp-Bg Image */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              position: "relative",
            }}
          >
            {/* Background Half Circles */}
            <Box
              component="img"
              src={halfCircles}
              alt=""
              aria-hidden="true"
              sx={{
                position: "absolute",
                width: "599px",
                height: "350px",
                objectFit: "contain",
                left: -80,
                "@media (max-width: 1200px)": {
                  left: 0,
                },
                "@media (max-width: 780px)": {
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "370px",
                  height: "auto",
                },
                zIndex: 0,
              }}
            />
            <Box
              component="img"
              src={immrsExpBg}
              // alt="Immersive Experience Image"
              sx={{
                position: "relative",
                zIndex: 1,
                width: "330px",
                height: "330px",
                "@media (max-width: 1200px)": {
                  width: "300px",
                  height: "300px",
                },
                "@media (max-width: 780px)": {
                  fontSize: "18px",
                  width: "174px",
                  height: "174px",
                  mt: 2,
                },
              }}
            />
          </Box>
        </Box>

        {/* What Embodies Immersive Experience Section */}
        <Box
          sx={{
            pb: "48px",
            pt: "48px",
            px: "84px",
            display:"flex",
            flexDirection:"column",
            "@media (max-width: 1200px)": {
              px: "24px",
            },
            "@media (max-width: 780px)": {
              px: "16px",
            //  display: "flex",
            //  flexWrap: "wrap",
            },
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: "3rem",
              fontWeight: "bold",
              textAlign: "left",
              color: "#2A2177",
              mb: "10px",
              "@media (max-width: 1200px)": {
                fontSize: "2.5rem",
              },
              "@media (max-width: 780px)": {
                fontSize: "2rem",
              },
            }}
          >
            What Embodies Immersive Experience
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "left",
              color: "#000000",
              mb: 2,
            }}
          >
            We don’t operate as external consultants.
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: "1rem",
              fontWeight: "regular",
              textAlign: "left",
              color: "#000000",
            }}
          >
            We become part of your team.
          </Typography>

          {/* Cards Container */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 3,
              "@media (max-width: 1200px)": {
                width: "720px",
                display: "contents",
                flexWrap: "wrap",
              },
              "@media (max-width: 780px)": {
                width: "100%",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                gap: 3,
                flexWrap: "wrap",
                margin: "0 auto",
                //  maxWidth: "1270px",
              }}
            >
              {/* We are embedded within your DAM implementation team */}
              <Box
                sx={{
                  width: "624px",
                  height: "80px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  mt: "32px",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "80px",
                    mt: "24px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "148px",
                    mt: "16px",
                  },
                }}
              >
                <GradientIcon
                  icon={ExtensionOutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    We are embedded within your DAM implementation team
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    We integrate directly into your team,
                    working as active contributors throughout
                    the implementation journey.
                  </Typography>
                </Box>
              </Box>

              {/* We work alongside practitioners, not above them */}
              <Box
                sx={{
                  width: "624px",
                  height: "80px",
                  borderRadius: "24px",
                  display: "flex",
                  alignItems: "center",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "80px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "148px",
                  },
                }}
              >
                <GradientIcon
                  icon={GroupOutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    We work alongside practitioners, not above them
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    We collaborate closely with your team members,
                    supporting execution rather than directing from
                    a distance.
                  </Typography>
                </Box>
              </Box>

              {/* We collaborate in real-time, not through disconnected communication */}
              <Box
                sx={{
                  width: "624px",
                  height: "80px",
                  borderRadius: "24px",
                  display: "flex",
                  alignItems: "center",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "80px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "176px",
                  },
                }}
              >
                <GradientIcon
                  icon={ForumOutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    We collaborate in real-time, not through
                    disconnected communication
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    We engage in continuous, real-time
                    collaboration to ensure alignment,
                    speed, and clarity.
                  </Typography>
                </Box>
              </Box>

              {/* We focus on execution, not just recommendations */}
              <Box
                sx={{
                  width: "624px",
                  height: "80px",
                  borderRadius: "24px",
                  display: "flex",
                  alignItems: "center",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "80px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "128px",
                  },
                }}
              >
                <GradientIcon
                  icon={BuildOutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    We focus on execution, not just recommendations
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    We actively implement solutions, turning
                    strategies into measurable outcomes.
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* ImmersiveExperience Infographic Image */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                "@media (max-width: 1200px)": {
                  justifyContent: "center",
                  order: 2,
                },
                "@media (max-width: 780px)": {
                  order: -1,
                  mb: "30px",
                },
              }}
            >
              <Box
                component="img"
                src={immrsInfographicBg}
                // alt="Immersive Experience Infographic"
                sx={{
                  width: "440px",
                  height: "440px",
                  "@media (max-width: 1200px)": {
                    width: "450px",
                    height: "450px",
                  },
                  "@media (max-width: 780px)": {
                    fontSize: "18px",
                    width: "328px",
                    height: "328px",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>

        {/* How We Work Section */}
        <Box
          sx={{
            py: "48px",
            px: "84px",
            backgroundColor: "#FFFFFF",
            "@media (max-width: 1200px)": {
              px: "24px",
            },
            "@media (max-width: 780px)": {
              p: "16px",
            },
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: "3rem",
              fontWeight: "bold",
              textAlign: "left",
              color: "#2A2177",
              mb: 3,
              "@media (max-width: 1200px)": {
                fontSize: "2.5rem",
              },
              "@media (max-width: 780px)": {
                fontSize: "2rem",
                textAlign: "center",
              },
            }}
          >
            How We Work
          </Typography>

          {/* Cards Container */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width : "100%",
              gap: 3,
              "@media (max-width: 1200px)": {
                width: "720px",
                display: "contents",
                flexWrap: "wrap",
              },
              "@media (max-width: 780px)": {
                width: "328px",
                flexDirection: "column",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                gap: 3,
                flexWrap: "wrap",
                // margin: "0 auto",
                //  maxWidth: "1270px",
              }}
            >
              {/* Embedded Collaboration */}
              <Box
                sx={{
                  width: "612px",
                  height: "84px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "80px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "80px",
                  },
                }}
              >
                <GradientIcon
                  icon={Groups2OutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    Embedded Collaboration
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    We integrate directly with your team,
                    participating in daily workflows,
                    discussions, and execution.
                  </Typography>
                </Box>
              </Box>

              {/* Team-Centric Approach */}
              <Box
                sx={{
                  width: "612px",
                  height: "100px",
                  borderRadius: "24px",
                  display: "flex",
                  alignItems: "center",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "100px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "100px",
                  },
                }}
              >
                <GradientIcon
                  icon={PeopleAltOutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    Team-Centric Approach
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    We don’t just speak to business
                    stakeholders—we work closely with the actual
                    team responsible for implementation.
                  </Typography>
                </Box>
              </Box>

              {/* Shared Ownership */}
              <Box
                sx={{
                  width: "612px",
                  height: "100px",
                  borderRadius: "24px",
                  display: "flex",
                  alignItems: "center",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "100px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "100px",
                  },
                }}
              >
                <GradientIcon
                  icon={HandshakeOutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    Shared Ownership
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    Our goals are aligned with your organization.
                    We work with a shared sense of responsibility,
                    not as an external vendor.
                  </Typography>
                </Box>
              </Box>

              {/* Execution Over Observation */}
              <Box
                sx={{
                  width: "612px",
                  height: "84px",
                  borderRadius: "24px",
                  display: "flex",
                  alignItems: "center",
                  py: "16px",
                  gap: "16px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    background: "linear-gradient(135deg, #724FD300 0%, #FC86AF1A 100%)",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.03)",
                  },
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    height: "80px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",
                    height: "100px",
                  },
                }}
              >
                <GradientIcon
                  icon={HandymanOutlinedIcon}
                  size={24}
                  bordered
                  boxSize={48}
                  borderRadius={8}
                  borderWidth={2}
                  angle="90"
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      mb: 0.5,
                      color: "#000000",
                      "@media (max-width: 1200px)": {
                        fontSize: "1rem",
                      },
                    }}
                  >
                    Execution Over Observation
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "regular",
                      color: "#666666",
                      lineHeight: 1.4,
                      "@media (max-width: 1200px)": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    We don’t manage from a distance—we actively
                    contribute to building, configuring, and
                    optimizing your DAM system.
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* DAM Journey & Others Box */}
            <Box
              sx={{
                display: "flex",
                textAlign: "center",
                width: "612px",
                height: "344px",
                background: "#D8D3FF",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
                "@media (max-width: 1200px)": {
                  width: "720px",
                  mt: "30px",
                  mx: "auto",
                },
                "@media (max-width: 780px)": {
                  width: "100%",//"328px",
                  flexDirection: "column",
                  height: "688px",
                  background: "#D8D3FF",
                },
              }}
            >
              {/* LEFT COLUMN */}
              <Box
                sx={{
                  width: "312px",
                  height: "344px",
                  borderRadius: "16px",
                  overflow: "hidden",
                  "@media (max-width: 1200px)": {
                    width: "360px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%"//"328px",
                  },
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    background: "#384DB1",
                    color: "#fff",
                    height: "64px",
                    px: "24px",
                    py: "16px",
                  }}
                >
                  <Typography
                    fontWeight="bold"
                    sx={{
                      fontSize: "1.5rem",
                    }}
                  >
                    DAM Journey
                  </Typography>
                </Box>

                {/* Rows */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    px: "32px",
                    py: "16px",
                    color: "#fff",
                    height: "56px",
                    backgroundColor:  "#3648A7",
                    fontSize: "1rem",
                  }}
                >
                  <CheckIcon sx={{ color: "#FFD54F", mr: 1 }} />
                  Embedded within your team
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    px: "32px",
                    py: "16px",
                    color: "#fff",
                    height: "56px",
                    backgroundColor:  "#3945A4",
                    fontSize: "1rem",
                  }}
                >
                  <CheckIcon sx={{ color: "#FFD54F", mr: 1 }} />
                  Real-time collaboration
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    px: "32px",
                    py: "16px",
                    color: "#fff",
                    height: "56px",
                    backgroundColor:  "#373C95",
                    fontSize: "1rem",
                  }}
                >
                  <CheckIcon sx={{ color: "#FFD54F", mr: 1 }} />
                  Hands-on execution
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    px: "32px",
                    py: "16px",
                    color: "#fff",
                    height: "56px",
                    backgroundColor:  "#39388F",
                    fontSize: "1rem",
                  }}
                >
                  <CheckIcon sx={{ color: "#FFD54F", mr: 1 }} />
                  Shared ownership
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    px: "32px",
                    py: "16px",
                    color: "#fff",
                    height: "56px",
                    backgroundColor:  "#39388F",
                    fontSize: "1rem",
                  }}
                >
                  <CheckIcon sx={{ color: "#FFD54F", mr: 1 }} />
                  Business-first approach
                </Box>
              </Box>

              {/* RIGHT COLUMN */}
              <Box
                sx={{
                  width: "312px",
                  height: "344px",
                  "@media (max-width: 1200px)": {
                    width: "360px",
                  },
                  "@media (max-width: 780px)": {
                    width: "100%",//"328px",
                    borderRadius: "16px",
                    overflow: "hidden",
                  },
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    background: "#D8D3FF",
                    color: "#2A2177",
                    height: "64px",
                    px: 3,
                    py: 2,
                  }}
                >
                  <Typography
                    fontWeight="bold"
                    sx={{
                      fontSize: "1.5rem",
                    }}
                  >
                    Others
                  </Typography>
                </Box>

                {/* Rows */}
                <Box
                  sx={{
                    px: "32px",
                    py: "16px",
                    height: "56px",
                    color: "#2A2177",
                    backgroundColor: "#E6E3FF",
                    textAlign: "left",
                    fontSize: "1rem",
                  }}
                >
                  Work remotely
                </Box>
                <Box
                  sx={{
                    px: "32px",
                    py: "16px",
                    color: "#2A2177",
                    backgroundColor: "#D8D3FF",
                    textAlign: "left",
                    fontSize: "1rem",
                  }}
                >
                  Limited team interaction
                </Box>
                <Box
                  sx={{
                    px: "32px",
                    py: "16px",
                    height: "56px",
                    color: "#2A2177",
                    backgroundColor: "#E6E3FF",
                    textAlign: "left",
                    fontSize: "1rem",
                  }}
                >
                  Strategy-focused only
                </Box>
                <Box
                  sx={{
                    px: "32px",
                    py: "16px",
                    height: "56px",
                    color: "#2A2177",
                    backgroundColor: "#D8D3FF",
                    textAlign: "left",
                    fontSize: "1rem",
                  }}
                >
                  Vendor-driven mindset
                </Box>
                <Box
                  sx={{
                    px: "32px",
                    py: "16px",
                    height: "56px",
                    color: "#2A2177",
                    backgroundColor: "#E6E3FF",
                    textAlign: "left",
                    fontSize: "1rem",
                  }}
                >
                  Tool-focused approach
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Have Questions Section */}
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default ImmersiveExperience;
